const updateGymsErrors = (state, { payload: { errors } }) => {
	state.errors = errors;
};

export default updateGymsErrors;
